import type { IllustrationName } from "@repo/fika-design-system/illustrations"
import { illustrationSvgs } from "@repo/fika-design-system/illustrations"
import { defaultProps } from "@/lib/default-props"
import { illustrationClass } from "./illustration.css"

export type IllustrationSize = "64" | "96" | "120" | "200"
type Props = {
  name: IllustrationName
  class?: string
  title?: string
  size?: IllustrationSize
}

export function Illustration(props: Props) {
  const defProps = defaultProps({ size: "120" }, props)
  const svgContent = illustrationSvgs[props.name]

  const viewBox = svgContent.match(/viewBox=["']([^"']+)["']/)?.[1]
  const innerContent = svgContent.replace(/<svg[^>]*>|<\/svg>/g, "")
  const content = props.title
    ? `<title>${props.title}</title>${innerContent}`
    : innerContent

  return (
    <svg
      class={[props.class, illustrationClass].join(" ")}
      width={defProps.size}
      height={defProps.size}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      innerHTML={content}
    />
  )
}
